import { useEffect } from "react";
import { Navigate, useLocation, useParams } from "react-router";
import { markSpaceChosen } from "../os/spaceChoice";
import { useWorkspace } from "./workspace-context";

/**
 * Registry deep links carry the department (`/w/{workspaceKey}/…`, emitted by the server for files, conversations and drafts): select it,
 * then continue to the rest of the path (shell-ia §14.1). Kept under every flag. WP-SHELL.
 */
export function WorkspaceEntry() {
  const { workspaceKey, "*": rest = "" } = useParams();
  const { search, hash } = useLocation();
  const { loading, workspaces, workspaceKey: current, setWorkspaceKey } = useWorkspace();
  const known = !!workspaceKey && workspaces.some((w) => w.key === workspaceKey);
  useEffect(() => {
    if (!known) return;
    markSpaceChosen(workspaceKey!);
    if (workspaceKey !== current) setWorkspaceKey(workspaceKey!);
  }, [known, workspaceKey, current, setWorkspaceKey]);
  if (loading || (known && workspaceKey !== current)) return null;
  return <Navigate to={`/${rest}${search}${hash}`} replace />;
}
